import { render, staticRenderFns } from "./TvLogin.vue?vue&type=template&id=386747e6&scoped=true&"
import script from "./TvLogin.vue?vue&type=script&lang=js&"
export * from "./TvLogin.vue?vue&type=script&lang=js&"
import style0 from "./TvLogin.vue?vue&type=style&index=0&id=386747e6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386747e6",
  null
  
)

export default component.exports